import { ApplicationScope } from 'mark43-federated-search';
import { AppName } from '../app-name/app-name';

export const appNameToApplicationScope = (appName: AppName) => {
    return {
        cad: ApplicationScope.CAD_DISPATCH,
        'first-responder': ApplicationScope.FIRST_RESPONDER,
    }[appName];
};
